var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.showMask === true)?_c('div',{staticClass:"c-mask"},[_c('div',{staticClass:"c-mask-wrapper"}),_c('pulse-loader',{attrs:{"color":"#F8CA4F","size":"80px"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }